export const environment = {
  production: true,
  fullStoryId: 'PN086',
  apiurl: 'https://app.rideroundtrip.com/api/v1/admin',
  apiv3url: 'https://app.rideroundtrip.com/api/v3',
  appurl: 'https://app.rideroundtrip.com/',
  configPortalUrl: 'https://config.live.rtrip.io/',
  googleApiKey: 'AIzaSyAC4LH12jFOwEoYguhJ8g5W-Sr6WSUFpo4',
  sqs_queue_url: 'https://sqs.us-east-1.amazonaws.com/146263503364/roundtrip-webhooks-v2-prod.fifo',
  launchDarklyClientApiKey: '60f722445bf2df25322ea4bb',
  auth0CallbackUrl: 'https://admin.live.rtrip.io',
  auth0ClientId: 'kCmb0FVZxisaelzb8qdgEqzYg1YJwtXt',
  auth0Domain: 'login.rideroundtrip.com',
  adminCreation: 'sam@roundtriphealth.com,brian.ryther@roundtriphealth.com'
};
